<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 @isShow="isShow" @showButton="showButtonO" ref="childTab1" />
      </el-tab-pane>
      <el-tab-pane label="审批流转" name="second" :key="'second'" :lazy="true">
        <childTab2 :isShow="isSho" @draftState="draftState" />
      </el-tab-pane>
      <el-tab-pane label="相关文档" name="third" :key="'third'" :lazy="true">
        <childTab3 :showButton="showButton" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MmplEditMain from '@/views/MouldManagement/MmplManage/TabChild/MmplEditMain.vue';
import MmplEditAppr from '@/views/MouldManagement/MmplManage/TabChild/MmplEditAppr';
import MmplEditAbout from '@/views/MouldManagement/MmplManage/TabChild/MmplEditAbout';

export default {
  name: 'AcctEdit',
  components: {
    childTab1: MmplEditMain,
    childTab2: MmplEditAppr,
    childTab3: MmplEditAbout
  },
  data() {
    return {
      activeName: 'first',
      isSho: true,
      showButton: {}
    };
  },
  created() {},
  methods: {
    isShow(val) {
      this.isSho = val;
    },
    showButtonO(val) {
      this.showButton = val;
    },
    draftState() {
      this.$refs.childTab1.initData();
    }
  }
};
</script>

<style scoped lang="scss"></style>
